import {
    IOnlineWidget,
    IPaymentChartsWidget,
    IPaymentsWidget,
    ISignUpsWidget,
    ISupportWidget
} from '@interfaces/consumer/dashboard';
import { ConsumerProjectInfo } from '@interfaces/consumer/project';
import IService from './iService';

export default class ConsumerService extends IService {

    async fetchConsumerProjectInfo() {
        return await this.getAndThrowApi<ConsumerProjectInfo>('/api/consumer/project/');
    }

    fetchOnlineWidget = async () => {
        return await this.getApi<IOnlineWidget>('/api/consumer/dashboard/online/');
    }

    fetchSignUpsWidget = async () => {
        return await this.getApi<ISignUpsWidget>('/api/consumer/dashboard/signups/');
    }

    fetchSupportWidget = async () => {
        return await this.getApi<ISupportWidget>('/api/consumer/dashboard/support/');
    }

    fetchPaymentsWidget = async () => {
        return await this.getApi<IPaymentsWidget>('/api/consumer/dashboard/payments/');
    }

    fetchPaymentChartsWidget = async () => {
        return await this.getApi<IPaymentChartsWidget>('/api/consumer/dashboard/payments/charts/');
    }
}